import React, {Component} from 'react';
import {Router, Route} from 'react-router-dom';
import {connect} from 'react-redux';

import { userActions } from '../actions';
import { history } from '../_helpers';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import NavBar from './NavBar/NavBar';
import Footer from './Footer/Footer';
import Schedule from './Schedule/Schedule';
import Dashboard from './Dashboard/Dashboard';
import Login from './Auth/Login/Login';
import Register from './Auth/Register/Register';
import ForgotPassword from './Auth/Forgot/ForgotPassword';
import ResetPassword from './Auth/Forgot/ResetPassword';
import AdminDashboard from './Admin/Dashboard/AdminDashboard';
import PrivateRoute from './PrivateRoute';
import AdminRoute from './Admin/AdminRoute';
import AdminAddGame from './Admin/Games/AdminAddGame';
import AdminEditGame from './Admin/Games/AdminEditGame';
import AdminViewRoster from './Admin/Games/AdminViewRoster';
import AdminEditUser from './Admin/Users/AdminEditUser';
import AccountEdit from './Account/Edit/AccountEdit';

class App extends Component {

    componentDidMount() {
        this.props.fetchUser();
    }

    render(){
        return (
            <div>
                <Router history={history}>
                    <div>
                        <NavBar />
                        <Route exact={true} path="/" component={Login}/>
                        <Route exact={true} path="/schedule" component={Schedule}/>
                        <Route exact path="/login"  component={Login} />
                        <Route exact path="/register"  component={Register} />
                        <Route exact path="/forgot"  component={ForgotPassword} />
                        <Route path="/reset"  component={ResetPassword} />
                        <PrivateRoute exact path="/dashboard" component={Dashboard}/>
                        <PrivateRoute exact path="/account/edit" component={AccountEdit}/>
                        <AdminRoute exact path="/admin" component={AdminDashboard}/>
                        <AdminRoute exact path="/admin/add-game/" component={AdminAddGame}/>
                        <AdminRoute exact path="/admin/edit-game/:id" component={AdminEditGame}/>
                        <AdminRoute exact path="/admin/game-roster/:id" component={AdminViewRoster}/>
                        <AdminRoute exact path="/admin/edit-user/:id" component={AdminEditUser}/>
                        <Footer />
                        <ToastContainer />
                    </div>
                </Router>
            </div>
        );
    }
};

function mapStateToProps(state){
    return {
        alert: state.alert
    }
}

export default connect(mapStateToProps, userActions)(App);


// WEBPACK FOOTER //
// ./src/components/App.js